import { translation as t } from "../utils/translation";
import { ROUTES } from "../constants/common";
import Header from "./header";
import CalculateByProduct from "./calculateByProduct";

const CalculateByProductContent = () => {

  return (
    <div id="CalculateByProductContent" className="mt-5">
      <Header
        title={t.CALCULATE_BY_PRODUCTS_BUTTON}
        description={t.HEADER_DESCRIPTION}
        buttonTitle={t.CALCULATE_MIXES_BUTTON_TITLE}
        buttonText={t.MORTGAGE_PLANING_IN_CLICK}
        buttonLink={ROUTES.CALCULATE_MIXES_CONTENT}
      />
      <CalculateByProduct />
    </div>
  );
};
export default CalculateByProductContent;